import * as React from 'react';

import { FormSectionContainerGrid } from '../../enums';

import { Container, SectionContent, SectionTitle } from './formSection.styled';
import { FormSectionProps } from './formSection.types';

export const FormSection: React.FC<FormSectionProps> = (props: FormSectionProps): JSX.Element => {
  const {
    title,
    children,
    className,
    desktopRowPosition = 'horizontal',
    containerGrid = FormSectionContainerGrid.Standard
  }: FormSectionProps = props;

  return (
    <Container className={className} $containerGrid={containerGrid} $desktopRowPosition={desktopRowPosition}>
      <SectionTitle $desktopRowPosition={desktopRowPosition}>{title}</SectionTitle>
      <SectionContent>{children}</SectionContent>
    </Container>
  );
};
